import { Icon } from '@material-ui/core';
import React, { Component } from 'react';
import styles from './MyIcon.css';

const CONST = {
  faceIconA: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 26">
      <path className="st1" fill="#1a70bb" d="M13,26c7.2,0,13-5.8,13-13S20.2,0,13,0,0,5.8,0,13s5.8,13,13,13Z" />
      <path className="st0" fill="#fff" d="M13,19.8c-4.1,0-6-3-6.1-3.2-.3-.5-.1-1.1.3-1.4.5-.3,1.1-.1,1.4.3,0,0,1.4,2.2,4.4,2.2s4.3-2.1,4.4-2.2c.3-.5.9-.6,1.4-.3s.6.9.3,1.4c0,.1-2,3.2-6.1,3.2Z" />
      <path className="st0" fill="#fff" d="M9.7,12.1c-.5,0-.9-.3-1-.8-.1-.8-.9-.8-1-.8-.2,0-.8,0-.9.8,0,.5-.6.9-1.1.8-.5,0-.9-.6-.8-1.1.2-1.5,1.4-2.5,2.9-2.5,1.5,0,2.7,1,3,2.5,0,.5-.3,1.1-.8,1.2,0,0-.1,0-.2,0Z" />
      <path className="st0" fill="#fff" d="M20.2,12.1c-.5,0-.9-.3-1-.8-.1-.8-.8-.8-1-.8h0c-.2,0-.8,0-.9.8,0,.5-.6.9-1.1.8-.5,0-.9-.6-.8-1.1.2-1.5,1.4-2.5,2.9-2.5h0c1.5,0,2.7,1,3,2.5,0,.5-.3,1.1-.8,1.2,0,0-.1,0-.2,0Z" />
    </svg>
  ),
  faceIconB: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 26">
      <path className="st1" fill="#4aad96" d="M13,26c7.2,0,13-5.8,13-13S20.2,0,13,0,0,5.8,0,13s5.8,13,13,13Z" />
      <circle className="st0" fill="#fff" cx="7.9" cy="10.6" r="1.6" />
      <path className="st0" fill="#fff" d="M18.1,12.2c-.9,0-1.7-.7-1.7-1.6s.7-1.6,1.7-1.6,1.6.7,1.6,1.6-.7,1.6-1.6,1.6Z" />
      <path className="st0" fill="#fff" d="M13,19.8c-4.1,0-6-3-6.1-3.2-.3-.5-.1-1.1.3-1.4.5-.3,1.1-.1,1.4.3,0,0,1.4,2.2,4.4,2.2s4.3-2.1,4.4-2.2c.3-.5.9-.6,1.4-.3s.6.9.3,1.4c0,.1-2,3.2-6.1,3.2Z" />
    </svg>
  ),
  faceIconC: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 26">
      <path className="st1" fill="#46b937" d="M13,26c7.2,0,13-5.8,13-13S20.2,0,13,0,0,5.8,0,13s5.8,13,13,13Z" />
      <circle className="st0" fill="#fff" cx="7.9" cy="10.6" r="1.6" />
      <path className="st0" fill="#fff" d="M18.1,12.2c-.9,0-1.7-.7-1.7-1.6s.7-1.6,1.7-1.6,1.6.7,1.6,1.6-.7,1.6-1.6,1.6Z" />
      <path className="st0" fill="#fff" d="M18.3,18H7.9c-.6,0-1-.4-1-1s.4-1,1-1h10.4c.6,0,1,.4,1,1s-.4,1-1,1Z" />
    </svg>
  ),
  faceIconD: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 26">
      <path className="st0" fill="#decc56" d="M13,26c7.2,0,13-5.8,13-13S20.2,0,13,0,0,5.8,0,13s5.8,13,13,13Z" />
      <circle className="st1" fill="#fff" cx="7.9" cy="10.6" r="1.6" />
      <path className="st1" fill="#fff" d="M18.1,12.2c-.9,0-1.7-.7-1.7-1.6s.7-1.6,1.7-1.6,1.6.7,1.6,1.6-.7,1.6-1.6,1.6Z" />
      <path className="st1" fill="#fff" d="M18.3,18.5c-.3,0-.7-.2-.9-.5,0,0-1.4-2.2-4.4-2.2s-4.3,2.1-4.4,2.2c-.3.5-.9.6-1.4.3-.5-.3-.6-.9-.3-1.4,0-.1,2-3.2,6.1-3.2s6,3,6.1,3.2c.3.5.1,1.1-.3,1.4-.2.1-.3.1-.5.1Z" />
    </svg>
  ),
  faceIconE: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 26">
      <path className="st0" fill="#f08838" d="M13,26c7.2,0,13-5.8,13-13S20.2,0,13,0,0,5.8,0,13s5.8,13,13,13Z" />
      <path className="st1" fill="#fff" d="M18.3,18.5c-.3,0-.7-.2-.9-.5,0,0-1.4-2.2-4.4-2.2s-4.3,2.1-4.4,2.2c-.3.5-.9.6-1.4.3-.5-.3-.6-.9-.3-1.4,0-.1,2-3.2,6.1-3.2s6,3,6.1,3.2c.3.5.1,1.1-.3,1.4-.2.1-.3.1-.5.1Z" />
      <path className="st1" fill="#fff" d="M18.1,12.4c-1.5,0-2.7-1-3-2.5,0-.5.3-1.1.8-1.2.5,0,1.1.3,1.2.8.1.8.8.8,1,.8h0c.2,0,.8,0,.9-.8,0-.5.6-.9,1.1-.8.5,0,.9.6.8,1.1-.2,1.5-1.4,2.5-2.9,2.5h0Z" />
      <path className="st1" fill="#fff" d="M7.9,12.4c-1.5,0-2.7-1-3-2.5,0-.5.3-1.1.8-1.2.5,0,1.1.3,1.2.8.1.8.9.8,1,.8.2,0,.8,0,.9-.8,0-.5.6-.9,1.1-.8.5,0,.9.6.8,1.1-.2,1.5-1.4,2.5-2.9,2.5h0Z" />
    </svg>
  ),
  faceIconF: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 26">
      <path className="st2" fill="#da3e41" d="M13,26c7.2,0,13-5.8,13-13S20.2,0,13,0,0,5.8,0,13s5.8,13,13,13Z" />
      <path className="st0" fill="#fff" fillRule="evenodd" d="M10.3,10c.4-.4.4-1,0-1.4-.4-.4-1-.4-1.4,0l-.7.7-.7-.7c-.4-.4-1-.4-1.4,0-.4.4-.4,1,0,1.4l.7.7-.7.7c-.4.4-.4,1,0,1.4.4.4,1,.4,1.4,0l.7-.7.7.7c.4.4,1,.4,1.4,0,.4-.4.4-1,0-1.4l-.7-.7.7-.7Z" />
      <path className="st0" fill="#fff" fillRule="evenodd" d="M19.5,10c.4-.4.4-1,0-1.4-.4-.4-1-.4-1.4,0l-.7.7-.7-.7c-.4-.4-1-.4-1.4,0-.4.4-.4,1,0,1.4l.7.7-.7.7c-.4.4-.4,1,0,1.4.4.4,1,.4,1.4,0l.7-.7.7.7c.4.4,1,.4,1.4,0,.4-.4.4-1,0-1.4l-.7-.7.7-.7Z" />
      <path className="st1" fill="#fff" d="M18.2,19.4c-.3,0-.7-.2-.9-.5,0,0-1.4-2.2-4.4-2.2s-4.3,2.1-4.4,2.2c-.3.5-.9.6-1.4.3-.5-.3-.6-.9-.3-1.4,0-.1,2-3.2,6.1-3.2s6,3,6.1,3.2c.3.5.1,1.1-.3,1.4-.2.1-.3.1-.5.1Z" />
    </svg>
  ),
  list: (
    <svg id="_レイヤー_1" data-name="レイヤー_1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 20 20">
      <path className="st0" fill="#1ab5bb" fillRule="evenodd" d="M3.3,1.8c-.1,0-.3.1-.3.3v15.8c0,.1.1.3.3.3h13.4c.1,0,.3-.1.3-.3V2.1c0-.1-.1-.3-.3-.3H3.3ZM1.5,2.1c0-1,.8-1.8,1.8-1.8h13.4c1,0,1.8.8,1.8,1.8v15.8c0,1-.8,1.8-1.8,1.8H3.3c-1,0-1.8-.8-1.8-1.8V2.1Z" />
      <path className="st0" fill="#1ab5bb" fillRule="evenodd" d="M7.4,6.2c0-.4.3-.8.8-.8h6.4c.4,0,.8.3.8.8s-.3.8-.8.8h-6.4c-.4,0-.8-.3-.8-.8ZM5.4,5.5c.4,0,.7.3.7.7s-.3.7-.7.7-.7-.3-.7-.7.3-.7.7-.7ZM7.4,10.2c0-.4.3-.8.8-.8h6.4c.4,0,.8.3.8.8s-.3.8-.8.8h-6.4c-.4,0-.8-.3-.8-.8ZM5.4,9.4c.4,0,.7.3.7.7s-.3.7-.7.7-.7-.3-.7-.7.3-.7.7-.7ZM7.4,14.1c0-.4.3-.8.8-.8h6.4c.4,0,.8.3.8.8s-.3.8-.8.8h-6.4c-.4,0-.8-.3-.8-.8ZM5.4,13.4c.4,0,.7.3.7.7s-.3.7-.7.7-.7-.3-.7-.7.3-.7.7-.7Z" />
    </svg>
  ),
  list_white: (
    <svg id="_レイヤー_1" data-name="レイヤー_1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 20 20">
      <path className="st0" fill="#1ab5bb" fillRule="evenodd" d="M3.3,1.8c-.1,0-.3.1-.3.3v15.8c0,.1.1.3.3.3h13.4c.1,0,.3-.1.3-.3V2.1c0-.1-.1-.3-.3-.3H3.3ZM1.5,2.1c0-1,.8-1.8,1.8-1.8h13.4c1,0,1.8.8,1.8,1.8v15.8c0,1-.8,1.8-1.8,1.8H3.3c-1,0-1.8-.8-1.8-1.8V2.1Z" />
      <path className="st0" fill="#1ab5bb" fillRule="evenodd" d="M7.4,6.2c0-.4.3-.8.8-.8h6.4c.4,0,.8.3.8.8s-.3.8-.8.8h-6.4c-.4,0-.8-.3-.8-.8ZM5.4,5.5c.4,0,.7.3.7.7s-.3.7-.7.7-.7-.3-.7-.7.3-.7.7-.7ZM7.4,10.2c0-.4.3-.8.8-.8h6.4c.4,0,.8.3.8.8s-.3.8-.8.8h-6.4c-.4,0-.8-.3-.8-.8ZM5.4,9.4c.4,0,.7.3.7.7s-.3.7-.7.7-.7-.3-.7-.7.3-.7.7-.7ZM7.4,14.1c0-.4.3-.8.8-.8h6.4c.4,0,.8.3.8.8s-.3.8-.8.8h-6.4c-.4,0-.8-.3-.8-.8ZM5.4,13.4c.4,0,.7.3.7.7s-.3.7-.7.7-.7-.3-.7-.7.3-.7.7-.7Z" />
    </svg>
  ),
  download: (
    <svg id="_レイヤー_1" data-name="レイヤー_1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 20 20">
      <path className="st0" fillRule="evenodd" fill="#fff" d="M3,1.8c-.2,0-.3.1-.3.3v16c0,.1.1.3.3.3h13.9c.2,0,.3-.1.3-.3V2c0-.1-.1-.3-.3-.3H3ZM1.2,2c0-1,.8-1.8,1.8-1.8h13.9c1,0,1.8.8,1.8,1.8v16c0,1-.8,1.8-1.8,1.8H3c-1,0-1.8-.8-1.8-1.8V2Z" />
      <path className="st1" fill="#fff" d="M9.4,13.8c.1.2.3.2.6.2s.4,0,.5-.2l3.2-3.5c.3-.3.3-.8,0-1.1-.3-.3-.8-.3-1.1,0l-2,2.1v-4.6c0-.4-.3-.8-.8-.8s-.7.3-.7.8v4.6l-2-2.1c-.3-.3-.8-.3-1.1,0-.3.3-.3.8,0,1.1l3.3,3.5Z" />
    </svg>
  ),
  upload: (
    <svg id="_レイヤー_1" data-name="レイヤー_1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 20 20">
      <path className="st0" fillRule="evenodd" fill="#fff" d="M3,1.8c-.2,0-.3.1-.3.3v16c0,.1.1.3.3.3h13.9c.2,0,.3-.1.3-.3V2c0-.1-.1-.3-.3-.3H3ZM1.2,2c0-1,.8-1.8,1.8-1.8h13.9c1,0,1.8.8,1.8,1.8v16c0,1-.8,1.8-1.8,1.8H3c-1,0-1.8-.8-1.8-1.8V2Z" />
      <path className="st1" fill="#fff" d="M10.6,6.2c-.1-.2-.3-.2-.6-.2s-.4,0-.5.2l-3.3,3.5c-.3.3-.3.8,0,1.1.3.3.8.3,1.1,0l2-2.1v4.6c0,.4.3.8.8.8s.7-.3.7-.8v-4.6l2,2.1c.3.3.8.3,1.1,0,.3-.3.3-.8,0-1.1l-3.2-3.5Z" />
    </svg>
  ),
  uploadExt: (
    <svg id="_レイヤー_1" data-name="レイヤー_1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 20 20">
      <path className="st0" fillRule="evenodd" fill="#D3AD45" d="M3,1.8c-.2,0-.3.1-.3.3v16c0,.1.1.3.3.3h13.9c.2,0,.3-.1.3-.3V2c0-.1-.1-.3-.3-.3H3ZM1.2,2c0-1,.8-1.8,1.8-1.8h13.9c1,0,1.8.8,1.8,1.8v16c0,1-.8,1.8-1.8,1.8H3c-1,0-1.8-.8-1.8-1.8V2Z" />
      <path className="st1" fill="#D3AD45" d="M10.6,6.2c-.1-.2-.3-.2-.6-.2s-.4,0-.5.2l-3.3,3.5c-.3.3-.3.8,0,1.1.3.3.8.3,1.1,0l2-2.1v4.6c0,.4.3.8.8.8s.7-.3.7-.8v-4.6l2,2.1c.3.3.8.3,1.1,0,.3-.3.3-.8,0-1.1l-3.2-3.5Z" />
    </svg>
  ),
};

class MyIcon extends Component {
  render() {
    const {
      color = 'default',
      type,
      animation = 'none',
      style,
      title = '',
      className = '',
      onClick = (() => { }),
    } = this.props;

    return (
      <Icon className={`${color} ${animation} ${styles.base} ${className}`} title={title} style={style} onClick={onClick} data-type={`${type}`}>
        {type in CONST && CONST[type]}
      </Icon>
    );
  }
}

export default MyIcon;
